import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

export enum EnumSibsPaymentRequestState {
    Confirm = 1,
    Waiting = 2
}

export interface ISibsPaymentRequestSummaryItem {
    Label: string;
    Value: string;
    Icon?: string; // ionicon
    Highlight?: boolean; // destaque (valor principal)
}

@Component({
    selector: 'app-sibs-payment-request',
    templateUrl: './sibs-payment-request.component.html',
    styleUrls: ['./sibs-payment-request.component.scss'],
})
export class SibsPaymentRequestModalComponent implements OnInit, OnDestroy {

    /** Tempo limite por omissão (minutos) quando o projeto não o configura. */
    private static readonly DEFAULT_TIMEOUT_MINUTES = 5;

    /** Tempo máximo de espera pelo pagamento no TPA (segundos), configurado em `Pages.Movements.PaymentRequestTimeoutMinutes`. */
    public readonly WaitSeconds: number;

    public EnumState = EnumSibsPaymentRequestState;

    public State: EnumSibsPaymentRequestState = EnumSibsPaymentRequestState.Confirm;

    public Summary: ISibsPaymentRequestSummaryItem[] = [];

    /** Terminal (TPA) onde o cliente efetua o pagamento. */
    public Terminal: string = '';

    /** Tempo limite do pagamento, em minutos (apresentado ao operador). */
    public readonly Minutes: number;

    public RemainingSeconds: number;

    private timer: any = null;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController) {

        const timeoutMinutes = Number(this.NavParams.get('timeoutMinutes'));

        this.Minutes = timeoutMinutes > 0 ? timeoutMinutes : SibsPaymentRequestModalComponent.DEFAULT_TIMEOUT_MINUTES;
        this.WaitSeconds = Math.round(this.Minutes * 60);
        this.RemainingSeconds = this.WaitSeconds;

        this.Summary = this.NavParams.get('summary') || [];
        this.Terminal = this.NavParams.get('terminal') || '';
    }

    ngOnInit() { }

    ngOnDestroy() {
        this.stopTimer();
    }

    /** Valor em destaque (ex.: comparticipação). */
    get Highlight(): ISibsPaymentRequestSummaryItem {
        return this.Summary.find(it => it?.Highlight) || null;
    }

    get Details(): ISibsPaymentRequestSummaryItem[] {
        return this.Summary.filter(it => !it?.Highlight);
    }

    get RemainingTime(): string {
        const minutes = Math.floor(this.RemainingSeconds / 60),
            seconds = this.RemainingSeconds % 60;

        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    /** Tempo de espera esgotado: só é possível cancelar e tentar novamente. */
    get IsExpired(): boolean {
        return this.State == EnumSibsPaymentRequestState.Waiting && this.RemainingSeconds == 0;
    }

    /** Percentagem de tempo decorrido (barra de progresso). */
    get Progress(): number {
        return 1 - (this.RemainingSeconds / this.WaitSeconds);
    }

    OnConfirm() {

        // PENDENTE: não é criado nenhum pedido de pagamento no backend; o modal só mostra a contagem decrescente.
        // Quando existir o contrato, criar o pedido aqui e aguardar o resultado do TPA
        this.State = EnumSibsPaymentRequestState.Waiting;

        this.startTimer();
    }

    /** Cancela (antes de confirmar ou com o tempo esgotado); o operador volta ao passo dos terminais. */
    OnCancel() {
        this.stopTimer();
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Cancel);
    }

    /**
     * O comerciante confirma que o cliente já pagou no TPA; segue para o registo da fatura.
     * PENDENTE: é uma confirmação manual (sempre disponível durante a espera), não o resultado do terminal.
     * Validar com o backend se deve passar a depender do estado do pagamento.
     */
    OnPaymentConfirmed() {
        this.stopTimer();
        this.ModalController.dismiss({ Confirmed: true }, EnumGenericRoleActionAlerts.Confirm);
    }

    private startTimer() {
        this.stopTimer();

        this.RemainingSeconds = this.WaitSeconds;

        this.timer = setInterval(() => {
            this.RemainingSeconds = Math.max(0, this.RemainingSeconds - 1);

            if (this.RemainingSeconds == 0) this.stopTimer();
        }, 1000);
    }

    private stopTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
}
